enum ContactType {
  Individual = "INDIVIDUAL",
  Business = "BUSINESS",
}

export default ContactType;
